import { useCallback } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { path } from 'ramda'

import { settingsKey } from 'app/reducers/settings/orgsOrders'
import usePagingExtended from 'app/common/hooks/usePagingExtended'


export default function useOrgsOrdersPagination() {
  const limit = useSelector(path(['settings', settingsKey, 'rows']), shallowEqual) as number

  const {
    currentPage,
    onPage: handlePage,
  } = usePagingExtended(limit)

  const offset = (currentPage - 1) * limit

  const resetPagination = useCallback(() => {
    handlePage(1)
  }, [handlePage])

  return { limit, offset, currentPage, handlePage, resetPagination }
}
